import * as React from "react";
const GMap = require('google-map-react');
const GoogleMapReact = GMap.default;
import ClusterMarker from "../cluster-marker";
import Marker from "../map-marker";
import ProductList from "./store-product-list";
export default class StoreMap extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const markers = this.props.clusters.map((store, index) => {
            let singleStore = store.numPoints <= 1 ? store.points[0] : null;
            let infoContent = singleStore ?
                React.createElement("div", { className: "store-info" },
                    React.createElement("a", { className: "title", href: `/Licensee/Index/${singleStore.storeInfo.Number}` }, singleStore.storeInfo.Name),
                    React.createElement("p", { className: "address" }, singleStore.storeInfo.StreetAddress),
                    React.createElement("p", null, `${singleStore.storeInfo.City.trim()},${singleStore.storeInfo.Province.trim()} ${singleStore.storeInfo.PostalCode.trim()}`),
                    React.createElement("p", { className: "phone" }, singleStore.storeInfo.Phone),
                    React.createElement("a", { href: `https://www.google.com/maps/dir//'${singleStore.storeInfo.Latitude},${singleStore.storeInfo.Longitude}'` }, "GET DIRECTIONS")) : null;
            return store.numPoints > 1 ? React.createElement(ClusterMarker, { lat: store.lat, lng: store.lng, numberOfPoints: store.numPoints, key: index, clusterMarkerClick: this.props.clusterMarkerClick }) :
                React.createElement(Marker, { lat: store.lat, lng: store.lng, infoContent: infoContent, key: index });
        });
        return (React.createElement("div", { className: "store-map" },
            this.props.showList ?
                React.createElement(ProductList, { products: this.props.products, store: this.props.showList.Products }) :
                null,
            React.createElement(GoogleMapReact, { ref: "googleMap", zoom: this.props.mapOptions.zoom, center: this.props.mapOptions.center, onChange: this.props.handleMapChange, yesIWantToUseGoogleMapApiInternals: true, bootstrapURLKeys: {
                    key: "AIzaSyAocKIHRwmXTDiWjHhcqak32fFCFeHw5Jw"
                } }, markers)));
    }
}
;
//# sourceMappingURL=store-map.js.map